// Emboldin theme JS — cart drawer, variant switching, gallery, qty
(function(){
  document.body.classList.add('emb-js');
  // ---- Cart drawer ----
  window.embOpenCart=function(){var o=document.getElementById('cartOverlay'),d=document.getElementById('cartDrawer');if(o)o.classList.add('show');if(d)d.classList.add('show');};
  window.embCloseCart=function(){var o=document.getElementById('cartOverlay'),d=document.getElementById('cartDrawer');if(o)o.classList.remove('show');if(d)d.classList.remove('show');};
  document.addEventListener('keydown',function(e){if(e.key==='Escape')window.embCloseCart();});

  // Refresh the cart drawer contents from /cart.js (mirrors snippets/cart-drawer.liquid)
  var embCmpCache={};
  function embCompareFor(it){
    var key=it.handle||String(it.product_id);
    if(!embCmpCache[key]){
      embCmpCache[key]=fetch('/products/'+it.handle+'.js').then(function(r){return r.json();}).then(function(p){
        var m={};(p.variants||[]).forEach(function(v){m[v.id]=v.compare_at_price||0;});return m;
      }).catch(function(){return {};});
    }
    return embCmpCache[key];
  }
  function embEsc(t){return String(t==null?'':t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var count=document.getElementById('cartCount');if(count)count.textContent=cart.item_count;
      var lines=document.getElementById('cartLines');if(!lines)return;
      var foot=document.querySelector('.cart-drawer-foot'),extras=document.getElementById('cartExtras');
      if(cart.item_count===0){
        lines.innerHTML='<div class="cart-empty"><div class="ce-title">Your cart is empty</div><p>The Everly Maxi is waiting, and it\'s buy one, get the rest half off.</p><a class="btn btn-primary" href="/collections/all">Shop now</a></div>';
        if(foot)foot.style.display='none';if(extras)extras.hidden=true;return;
      }
      return Promise.all(cart.items.map(embCompareFor)).then(function(maps){
        var html='',cmpSave=0,hasDress=false,hasRing=false;
        cart.items.forEach(function(it,i){
          var h=it.handle||'';
          if(/dress|maxi/.test(h))hasDress=true;
          if(/massager|ring/.test(h))hasRing=true;
          var cmp=(maps[i]||{})[it.variant_id]||0,was='';
          if(cmp>it.original_price){cmpSave+=(cmp-it.original_price)*it.quantity;was='<span class="cl-was">'+formatMoney(cmp*it.quantity)+'</span>';}
          var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2'):'';
          var meta=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="cl-meta">'+embEsc(it.variant_title)+'</div>':'';
          html+='<div class="cart-line"><img src="'+img+'" alt="" width="72" height="90"><div class="cart-line-info">'
            +'<div class="cl-top"><div class="cl-name">'+embEsc(it.product_title)+'</div><a class="cl-remove" href="/cart/change?line='+(i+1)+'&quantity=0">Remove</a></div>'+meta
            +'<div class="cl-bottom"><div class="cl-qty"><button type="button" class="cl-q" data-line="'+(i+1)+'" data-qty="'+(it.quantity-1)+'" aria-label="Decrease quantity">&minus;</button><span>'+it.quantity+'</span><button type="button" class="cl-q" data-line="'+(i+1)+'" data-qty="'+(it.quantity+1)+'" aria-label="Increase quantity">+</button></div>'
            +'<div class="cl-prices">'+was+'<span class="cl-price">'+formatMoney(it.final_line_price)+'</span></div></div></div></div>';
        });
        lines.innerHTML=html;
        var sub=document.getElementById('cartSubtotal');if(sub)sub.textContent=formatMoney(cart.total_price);
        var save=cmpSave+(cart.total_discount||0),sv=document.getElementById('cartSave'),sa=document.getElementById('cartSaveAmt');
        if(sv){sv.hidden=!(save>0);if(sa)sa.textContent=formatMoneyShort(save);}
        var bogo=document.getElementById('cartBogo');if(bogo)bogo.hidden=!hasDress;
        var g=document.getElementById('cartGuarText');
        if(g)g.innerHTML=(hasDress&&hasRing)?'<b>30-day returns on every item.</b> Free size swaps on dresses.':(hasDress?'<b>30-day happy returns.</b> Free size swaps, both ways.':'<b>30-day love-it-or-return-it guarantee.</b> Full refund, even if you\'ve used it.');
        var rv=document.getElementById('cartReview');if(rv)rv.hidden=!hasRing;
        if(extras)extras.hidden=false;
        if(foot)foot.style.display='';
      });
    });
  }
  function formatMoney(cents){return '$'+(cents/100).toFixed(2);}
  function formatMoneyShort(cents){return cents%100===0?'$'+(cents/100):'$'+(cents/100).toFixed(2);}

  // Any click that would go to the cart PAGE opens the side drawer instead — no /cart page in the flow.
  document.addEventListener('click',function(e){
    var t=e.target;var a=(t&&t.closest)?t.closest('a[href]'):null;
    if(!a)return;
    var h=a.getAttribute('href')||'';
    if(a.classList.contains('cart-btn')||h==='/cart'||/\/cart(\?|#|$)/.test(h)){
      e.preventDefault();
      try{refreshCart();}catch(_){}
      if(window.embOpenCart)window.embOpenCart();
    }
  },true);

  // Remove links inside the drawer update it in place (no jump to the cart page)
  document.addEventListener('click',function(e){
    var t=e.target;var r=(t&&t.closest)?t.closest('.cl-remove'):null;
    if(!r)return;
    e.preventDefault();
    var href=r.getAttribute('href')||'';
    fetch(href,{headers:{'Accept':'application/json'}})
      .then(function(){try{refreshCart();}catch(_){}})
      .catch(function(){try{refreshCart();}catch(_){}});
  },true);

  // Quantity +/- inside the drawer
  document.addEventListener('click',function(e){
    var b=(e.target&&e.target.closest)?e.target.closest('.cl-q'):null;
    if(!b)return;
    e.preventDefault();
    var line=parseInt(b.getAttribute('data-line'),10),q=Math.max(0,parseInt(b.getAttribute('data-qty'),10)||0);
    b.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:q})})
      .then(function(){try{refreshCart();}catch(_){}})
      .catch(function(){try{refreshCart();}catch(_){}});
  },true);

  // Intercept product form submit -> AJAX add, then open drawer
  document.addEventListener('submit',function(e){
    var form=e.target;
    var _act=(form.getAttribute&&(form.getAttribute('action')||''))||'';
    var _isAdd=form.id==='productForm'||/\/cart\/add/.test(_act)||(form.querySelector&&form.querySelector('[name=add],[name="add"]'));
    if(_isAdd){
      e.preventDefault();
      var btn=form.querySelector('[name=add]');if(btn){btn.disabled=true;btn.dataset.t=btn.textContent;btn.textContent='Adding…';}
      var err=document.getElementById('buyError');if(err){err.style.display='none';}
      var data=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}})
        .then(function(r){return r.json().then(function(body){return {ok:r.ok,body:body};});})
        .then(function(res){
          if(btn){btn.disabled=false;btn.textContent=btn.dataset.t;}
          if(!res.ok||res.body.status){
            if(err){err.textContent=(res.body&&res.body.description)||(res.body&&res.body.message)||'Sorry, that item could not be added.';err.style.display='';}
            return;
          }
          refreshCart();window.embOpenCart();
        })
        .catch(function(){
          if(btn){btn.disabled=false;btn.textContent=btn.dataset.t;}
          if(err){err.textContent='Something went wrong adding to your cart. Please try again.';err.style.display='';}
        });
    }
  });

  // ---- Product gallery ----
  function embThumbs(){return Array.prototype.slice.call(document.querySelectorAll('#galThumbs button'));}
  function embZoomThumbs(){return embThumbs();}
  var embSuppressJump=false;
  function embMediaColor(mid){
    var el=document.getElementById('mediaColorMap');if(!el||!mid)return null;
    var map;try{map=JSON.parse(el.textContent);}catch(e){return null;}
    return map[String(mid)]||null;
  }
  function embSelectColor(color){
    if(!color)return;
    var scope=document.querySelector('.pdp-wrap')||document;
    var radios=scope.querySelectorAll('input[data-color-input]');
    for(var r=0;r<radios.length;r++){
      if(radios[r].value===color){
        if(!radios[r].checked){
          radios[r].checked=true;
          embSuppressJump=true;                 // don't re-jump the image (we're already on it)
          if(window.embOnOptionChange)window.embOnOptionChange();
          embSuppressJump=false;
        }
        return;
      }
    }
  }
  // Image cache: each gallery image is downloaded and decoded once, so switching is instant
  var embImgCache={};
  function embLoadImg(src){
    if(!embImgCache[src]){
      var im=new Image();im.decoding='async';im.src=src;
      embImgCache[src]=(im.decode?im.decode():new Promise(function(r,j){im.onload=r;im.onerror=j;}))
        .then(function(){return true;},function(){return false;});
    }
    return embImgCache[src];
  }
  function embPreloadGallery(){
    var go=function(){embThumbs().forEach(function(b){var s=b.getAttribute('data-full');if(s)embLoadImg(s);});};
    if(window.requestIdleCallback){requestIdleCallback(go,{timeout:1500});}else{setTimeout(go,300);}
  }
  window.addEventListener('load',embPreloadGallery);
  var embNextHow=null; // set by a swipe: 'next' or 'prev'
  function embSwapMain(m,src,how){
    var tok=(m._embTok=(m._embTok||0)+1);
    var W=m.parentNode?m.parentNode.clientWidth:m.clientWidth;
    if(how){ // slide the current image out the way the finger went
      m.style.transition='transform .18s ease-out';
      m.style.transform='translateX('+(how==='next'?-W:W)+'px)';
    }
    var outDone=new Promise(function(r){setTimeout(r,how?180:0);});
    Promise.all([embLoadImg(src),outDone]).then(function(){
      if(m._embTok!==tok)return;
      m.src=src;
      if(how){ // bring the new image in from the opposite side
        m.style.transition='none';
        m.style.transform='translateX('+(how==='next'?W:-W)+'px)';
        void m.offsetWidth;
        m.style.transition='transform .22s ease-out';
        m.style.transform='translateX(0)';
      }else{m.style.transform='';}
    });
  }
  function embUpdateDots(i){
    var d=document.querySelectorAll('.gal-dots span');
    for(var k=0;k<d.length;k++){d[k].classList.toggle('on',k===i);}
  }
  function embSelectThumb(btn){
    var m=document.getElementById('pdpMain');var src=btn.getAttribute('data-full');
    var how=embNextHow;embNextHow=null;
    var idx=embThumbs().indexOf(btn);
    if(m&&src){
      if(m.getAttribute('src')!==src){embSwapMain(m,src,how);}
      else{m.style.transition='transform .2s ease-out';m.style.transform='translateX(0)';}
      m.setAttribute('data-index', idx);
      m.setAttribute('data-media-id', btn.getAttribute('data-media-id')||'');}
    embUpdateDots(idx);
    embThumbs().forEach(function(b){b.classList.remove('sel');});btn.classList.add('sel');
    if(window.embOnGallerySelect)window.embOnGallerySelect(btn);
    // keep active thumb in view
    if(btn.scrollIntoView){btn.scrollIntoView({block:'nearest',inline:'nearest'});}
    // click-image-to-select-color: if this image belongs to a color variant, select that color
    embSelectColor(embMediaColor(btn.getAttribute('data-media-id')));
  }
  // On load, align the selected color to whatever image is showing first
  function embSyncColorToMainImage(){
    var m=document.getElementById('pdpMain');if(!m)return;
    embSelectColor(embMediaColor(m.getAttribute('data-media-id')));
  }
  window.addEventListener('load',embSyncColorToMainImage);
  document.addEventListener('DOMContentLoaded',embSyncColorToMainImage);
  window.embSetMainByBtn=function(btn){embSelectThumb(btn);};
  window.embGalStep=function(dir){
    var t=embThumbs();if(!t.length)return;
    var m=document.getElementById('pdpMain');
    var i=parseInt(m&&m.getAttribute('data-index')||'0');
    i=(i+dir+t.length)%t.length;
    if(!embNextHow)embNextHow=dir>0?'next':'prev';
    embSelectThumb(t[i]);
  };
  // Swipe between images on touch screens (the image follows your finger)
  function embInitSwipe(){
    var box=document.querySelector('.pdp-gallery .gal-main');var m=document.getElementById('pdpMain');
    if(!box||!m||box._embSwipe||embThumbs().length<2)return;box._embSwipe=true;
    // position dots
    var dots=document.createElement('div');dots.className='gal-dots';dots.setAttribute('aria-hidden','true');
    embThumbs().forEach(function(){dots.appendChild(document.createElement('span'));});
    box.appendChild(dots);embUpdateDots(parseInt(m.getAttribute('data-index')||'0'));
    var x0=0,y0=0,dx=0,t0=0,mode=null;
    box.addEventListener('touchstart',function(e){
      if(e.touches.length!==1||e.target.closest('button'))return;
      x0=e.touches[0].clientX;y0=e.touches[0].clientY;dx=0;t0=Date.now();mode='?';
      m.style.transition='none';
    },{passive:true});
    box.addEventListener('touchmove',function(e){
      if(!mode)return;
      var cx=e.touches[0].clientX-x0,cy=e.touches[0].clientY-y0;
      if(mode==='?'){if(Math.abs(cx)<8&&Math.abs(cy)<8)return;mode=Math.abs(cx)>Math.abs(cy)?'x':'y';}
      if(mode!=='x')return;
      dx=cx;m.style.transform='translateX('+dx+'px)';
      var vl=box.querySelector('.gal-video:not([hidden])');if(vl){vl.style.transition='none';vl.style.transform='translateX('+dx+'px)';}
    },{passive:true});
    function end(){
      if(mode!=='x'){mode=null;return;}
      mode=null;box._embSwipedAt=Date.now();
      var fast=Math.abs(dx)>25&&(Date.now()-t0)<250;
      if(Math.abs(dx)>box.clientWidth*0.18||fast){
        embNextHow=dx<0?'next':'prev';
        window.embGalStep(dx<0?1:-1);
      }else{
        m.style.transition='transform .2s ease-out';m.style.transform='translateX(0)';
        var vl2=box.querySelector('.gal-video:not([hidden])');if(vl2){vl2.style.transition='transform .2s ease-out';vl2.style.transform='translateX(0)';}
      }
    }
    box.addEventListener('touchend',end,{passive:true});
    box.addEventListener('touchcancel',end,{passive:true});
  }
  document.addEventListener('DOMContentLoaded',embInitSwipe);
  window.addEventListener('load',embInitSwipe);
  // ---- Tap to zoom: full-screen image viewer with all images underneath ----
  function embZoomSrc(src){return /width=\d+/.test(src)?src.replace(/width=\d+/,'width=2048'):src;}
  var LB=null;
  function embBuildLightbox(){
    if(LB)return LB;
    var t=embZoomThumbs();if(!t.length)return null;
    var el=document.createElement('div');el.className='lb';el.setAttribute('role','dialog');el.setAttribute('aria-modal','true');el.setAttribute('aria-label','Product images');el.hidden=true;
    var th='';
    t.forEach(function(b,i){var im=b.querySelector('img');var isV=b.hasAttribute('data-video');th+='<button type="button" class="lb-th'+(isV?' lb-th-video':'')+'" data-i="'+i+'" aria-label="'+(isV?'Video':'Image '+(i+1))+'"><img src="'+(im?im.getAttribute('src'):b.getAttribute('data-full'))+'" alt=""></button>';});
    el.innerHTML='<div class="lb-top"><span class="lb-count"></span><button type="button" class="lb-x" aria-label="Close">&times;</button></div>'+
      '<div class="lb-stage"><img class="lb-img" alt="" draggable="false"><video class="lb-video" playsinline muted loop preload="none" hidden></video><button type="button" class="lb-vplay" aria-label="Play video" hidden><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6.2v11.6l9.2-5.8z"/></svg></button>'+
      (t.length>1?'<button type="button" class="lb-arrow lb-prev" aria-label="Previous image">&#8249;</button><button type="button" class="lb-arrow lb-next" aria-label="Next image">&#8250;</button>':'')+
      '</div><div class="lb-hint"></div><div class="lb-thumbs">'+th+'</div>';
    document.body.appendChild(el);
    var stage=el.querySelector('.lb-stage'),img=el.querySelector('.lb-img');
    var vid=el.querySelector('.lb-video'),vplay=el.querySelector('.lb-vplay');
    var st={i:0,s:1,x:0,y:0,last:null,vid:false};
    var hintTxt='';
    var lastTouchToggle=0;
    function vToggle(){if(vid.paused){var pr=vid.play();if(pr&&pr.catch)pr.catch(function(){});}else{vid.pause();}}
    vid.addEventListener('play',function(){vplay.hidden=true;});
    vid.addEventListener('pause',function(){if(st.vid)vplay.hidden=false;});
    vplay.addEventListener('click',function(e){e.stopPropagation();vToggle();});
    var touchUI=('ontouchstart' in window)||navigator.maxTouchPoints>0;
    hintTxt=touchUI?'Pinch or double-tap to zoom':'Click to zoom';
    el.querySelector('.lb-hint').textContent=hintTxt;
    function clampPan(){
      var W=stage.clientWidth,H=stage.clientHeight,nw=img.naturalWidth||W,nh=img.naturalHeight||H;
      var r=Math.min(W/nw,H/nh),cw=nw*r,ch=nh*r; // size of the photo itself inside the stage
      var mx=Math.max(0,(cw*st.s-W)/2),my=Math.max(0,(ch*st.s-H)/2);
      st.x=Math.max(-mx,Math.min(mx,st.x));st.y=Math.max(-my,Math.min(my,st.y));
    }
    function apply(anim){
      img.style.transition=anim?'transform .22s ease-out':'none';
      img.style.transform='translate('+st.x+'px,'+st.y+'px) scale('+st.s+')';
      el.classList.toggle('lb-zoomed',st.s>1.01);
    }
    function reset(anim){st.s=1;st.x=0;st.y=0;apply(anim);}
    function zoomAt(cx,cy,s){ // keep the point under the finger/cursor fixed
      var r=stage.getBoundingClientRect();var px=cx-(r.left+r.width/2),py=cy-(r.top+r.height/2);
      st.x=(px-st.x)*(1-s/st.s)+st.x;st.y=(py-st.y)*(1-s/st.s)+st.y;st.s=s;clampPan();
    }
    function show(i){
      var tt=embZoomThumbs();st.i=(i+tt.length)%tt.length;reset(false);
      st.vid=tt[st.i].hasAttribute('data-video');vid.style.transition='none';vid.style.transform='';
      el.classList.toggle('lb-is-video',st.vid);
      el.querySelector('.lb-hint').textContent=st.vid?'Tap to play or pause':hintTxt;
      if(st.vid){
        var gs=document.querySelector('.gal-video video source');
        if(gs&&vid.getAttribute('src')!==gs.getAttribute('src')){vid.setAttribute('src',gs.getAttribute('src'));var gv=document.querySelector('.gal-video video');if(gv&&gv.poster)vid.poster=gv.poster;}
        img.hidden=true;vid.hidden=false;vid.pause();vid.currentTime=0;vplay.hidden=false;
      }else{
        if(!vid.paused)vid.pause();vid.hidden=true;vplay.hidden=true;img.hidden=false;
      }
      var full=tt[st.i].getAttribute('data-full');img.src=full;
      var big=embZoomSrc(full);if(big!==full){var tok=st.i;embLoadImg(big).then(function(ok){if(ok&&st.i===tok&&!LB.el.hidden)img.src=big;});}
      el.querySelector('.lb-count').textContent=(st.i+1)+' / '+tt.length;
      el.querySelectorAll('.lb-th').forEach(function(b,k){b.classList.toggle('sel',k===st.i);if(k===st.i&&b.scrollIntoView)b.scrollIntoView({block:'nearest',inline:'center'});});
    }
    function close(){
      el.hidden=true;document.documentElement.classList.remove('lb-open');if(!vid.paused)vid.pause();
      var tt=embZoomThumbs();var m=document.getElementById('pdpMain');
      var real=tt[st.i]?embThumbs().indexOf(tt[st.i]):-1;
      if(m&&real>-1&&parseInt(m.getAttribute('data-index')||'0')!==real){embSelectThumb(tt[st.i]);}
      if(LB.from&&LB.from.focus)LB.from.focus();
    }
    el.querySelector('.lb-x').addEventListener('click',close);
    if(t.length>1){
      el.querySelector('.lb-prev').addEventListener('click',function(){show(st.i-1);});
      el.querySelector('.lb-next').addEventListener('click',function(){show(st.i+1);});
    }
    el.querySelector('.lb-thumbs').addEventListener('click',function(e){var b=e.target.closest('.lb-th');if(b)show(parseInt(b.getAttribute('data-i')));});
    document.addEventListener('keydown',function(e){
      if(el.hidden)return;
      if(e.key==='Escape')close();else if(e.key==='ArrowRight')show(st.i+1);else if(e.key==='ArrowLeft')show(st.i-1);
    });
    // Mouse: click toggles zoom, moving the mouse explores the zoomed image
    stage.addEventListener('click',function(e){
      if(e.target.closest('button'))return;
      if(st.vid){if(Date.now()-lastTouchToggle>600)vToggle();return;}
      if(touchUI)return;
      if(st.s>1.01){reset(true);}else{zoomAt(e.clientX,e.clientY,2.5);apply(true);}
    });
    stage.addEventListener('mousemove',function(e){
      if(touchUI||st.vid||st.s<=1.01)return;
      var r=stage.getBoundingClientRect();
      st.x=(0.5-(e.clientX-r.left)/r.width)*(st.s-1)*r.width;
      st.y=(0.5-(e.clientY-r.top)/r.height)*(st.s-1)*r.height;clampPan();apply(false);
    });
    // Touch: swipe to change image, pinch or double-tap to zoom, drag to pan while zoomed
    var g=null,lastTap=0;
    function dist(a,b){return Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);}
    stage.addEventListener('touchstart',function(e){
      if(e.target.closest('button'))return;
      if(e.touches.length===2){
        if(st.vid){g=null;return;}
        var a=e.touches[0],b=e.touches[1];
        g={k:'pinch',d0:dist(a,b),s0:st.s,mx:(a.clientX+b.clientX)/2,my:(a.clientY+b.clientY)/2};
      }else if(e.touches.length===1){
        var p=e.touches[0];
        g={k:st.s>1.01?'pan':'swipe',x0:p.clientX,y0:p.clientY,tx0:st.x,ty0:st.y,dx:0,dy:0,t0:Date.now()};
      }
    },{passive:true});
    stage.addEventListener('touchmove',function(e){
      if(!g)return;e.preventDefault();
      if(g.k==='pinch'&&e.touches.length===2){
        var a=e.touches[0],b=e.touches[1];
        var s=Math.max(1,Math.min(4,g.s0*dist(a,b)/g.d0));zoomAt(g.mx,g.my,s);apply(false);
      }else if(e.touches.length===1&&g.k!=='pinch'){
        var p=e.touches[0];g.dx=p.clientX-g.x0;g.dy=p.clientY-g.y0;
        if(g.k==='pan'){st.x=g.tx0+g.dx;st.y=g.ty0+g.dy;clampPan();apply(false);}
        else{var tg=st.vid?vid:img;tg.style.transition='none';tg.style.transform='translateX('+g.dx+'px)';}
      }
    },{passive:false});
    stage.addEventListener('touchend',function(e){
      if(!g)return;
      if(g.k==='pinch'){if(e.touches.length===0){if(st.s<1.05)reset(true);g=null;}return;}
      var moved=Math.abs(g.dx)>10||Math.abs(g.dy)>10;
      if(g.k==='swipe'){
        if(Math.abs(g.dx)>60&&Math.abs(g.dx)>Math.abs(g.dy)){show(st.i+(g.dx<0?1:-1));}
        else{apply(true);vid.style.transition='transform .22s ease-out';vid.style.transform='';}
      }
      if(!moved){ // double-tap toggles zoom where you tapped
        var now=Date.now();
        if(st.vid){lastTouchToggle=now;vToggle();}
        else if(now-lastTap<300){lastTap=0;if(st.s>1.01){reset(true);}else{zoomAt(g.x0,g.y0,2.5);apply(true);}}
        else{lastTap=now;}
      }
      g=null;
    });
    LB={el:el,show:show};return LB;
  }
  window.embOpenZoom=function(from){
    var lb=embBuildLightbox();if(!lb)return;
    var m=document.getElementById('pdpMain');
    lb.from=from||null;lb.el.hidden=false;document.documentElement.classList.add('lb-open');
    var cur=embThumbs()[parseInt(m&&m.getAttribute('data-index')||'0')];
    var zi=cur?embZoomThumbs().indexOf(cur):0;
    lb.show(zi>-1?zi:0);
    var x=lb.el.querySelector('.lb-x');if(x)x.focus();
  };
  function embInitZoom(){
    var box=document.querySelector('.pdp-gallery .gal-main');var m=document.getElementById('pdpMain');
    if(!box||!m||box._embZoom)return;box._embZoom=true;
    var btn=document.createElement('button');btn.type='button';btn.className='gal-zoom';btn.setAttribute('aria-label','Zoom image');
    btn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5l5 5M10.5 7.5v6M7.5 10.5h6"/></svg>';
    btn.addEventListener('click',function(){window.embOpenZoom(btn);});
    box.appendChild(btn);
    m.addEventListener('click',function(){
      if(box._embSwipedAt&&Date.now()-box._embSwipedAt<450)return;
      window.embOpenZoom(btn);
    });
  }
  document.addEventListener('DOMContentLoaded',embInitZoom);
  window.addEventListener('load',embInitZoom);

  // Page the thumbnail strip left/right by roughly one visible row
  window.embThumbScroll=function(dir){
    var t=document.getElementById('galThumbs');if(!t)return;
    var amt=Math.max(t.clientWidth*0.8,160);
    t.scrollBy({left:dir*amt,behavior:'smooth'});
  };
  // Hide the paging arrows when the strip isn't wide enough to scroll
  function embInitThumbArrows(){
    var t=document.getElementById('galThumbs');
    var w=document.getElementById('galThumbWrap');
    if(!t||!w)return;
    if(t.scrollWidth <= t.clientWidth + 4){w.classList.add('no-scroll');}
    else{w.classList.remove('no-scroll');}
  }
  window.addEventListener('load',embInitThumbArrows);
  document.addEventListener('DOMContentLoaded',embInitThumbArrows);
  window.addEventListener('resize',embInitThumbArrows,{passive:true});
  setTimeout(embInitThumbArrows,400);setTimeout(embInitThumbArrows,1200);
  // ---- Sticky mobile buy bar ----
  window.embStickyAdd=function(){
    var form=document.getElementById('productForm');if(!form)return;
    if(form.requestSubmit){form.requestSubmit();}
    else{form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));}
  };
  function embInitStickyBar(){
    var mainBuy=document.querySelector('.buy-actions');
    var sticky=document.getElementById('stickyBuy');
    if(!mainBuy||!sticky||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        // show only once the main Add-to-bag has scrolled ABOVE the viewport
        if(!en.isIntersecting && en.boundingClientRect.top < 0){sticky.classList.add('show');}
        else{sticky.classList.remove('show');}
      });
    },{threshold:0});
    io.observe(mainBuy);
  }
  window.addEventListener('load',embInitStickyBar);
  document.addEventListener('DOMContentLoaded',embInitStickyBar);

  // Jump gallery to a variant's assigned image (by media id)
  window.embJumpToVariantImage=function(variantId){
    var el=document.getElementById('variantImages');if(!el)return false;
    var map;try{map=JSON.parse(el.textContent);}catch(e){return false;}
    var mediaId=map[variantId];if(!mediaId)return false;
    var t=embThumbs();
    for(var k=0;k<t.length;k++){
      if(t[k].getAttribute('data-media-id')===String(mediaId)){embSelectThumb(t[k]);return true;}
    }
    return false;
  };
  // Fallback: no variant image assigned -> find a photo whose alt text names the color
  function embJumpToColorImage(color){
    if(!color)return false;
    var c=String(color).trim().toLowerCase();if(!c)return false;
    var t=embThumbs();
    for(var i=0;i<t.length;i++){
      var img=t[i].querySelector('img');
      var alt=img?((img.getAttribute('alt')||'').toLowerCase()):'';
      if(alt.indexOf(c)>-1){embSelectThumb(t[i]);return true;}
    }
    return false;
  }

  // ---- Quantity ----
  window.embQty=function(d){var i=document.getElementById('qtyInput');if(!i)return;i.value=Math.max(1,parseInt(i.value||'1')+d);};

  // ---- Variant selection ----
  function embVariants(){
    var el=document.getElementById('variantData');if(!el)return[];
    try{return JSON.parse(el.textContent);}catch(e){return[];}
  }
  function embMoney(cents){return '$'+(cents/100).toFixed(2).replace(/\.00$/,'');}
  window.embOnOptionChange=function(){
    var form=document.getElementById('productForm');if(!form)return;
    var scope=document.querySelector('.pdp-wrap')||document;
    // Read chosen values BY OPTION POSITION (option1, option2...) so order/separator never matters
    var chosen=[];
    scope.querySelectorAll('input[name^="option"]:checked').forEach(function(r){
      var m=(r.name||'').match(/option(\d+)/);
      if(m){chosen[parseInt(m[1],10)-1]=r.value;}
    });
    // update current-value labels + swatch/pill selected styling BY VALUE
    // (value-based, not checked-based, so duplicate color copies stay in sync)
    scope.querySelectorAll('.opt-group').forEach(function(g){
      var anyInput=g.querySelector('input[name^="option"]');
      var pos=null;
      if(anyInput){var mm=(anyInput.name||'').match(/option(\d+)/);if(mm)pos=parseInt(mm[1],10)-1;}
      var val=(pos!=null)?chosen[pos]:null;
      var lbl=g.querySelector('.opt-current');
      if(lbl&&val!=null)lbl.textContent=val;
      g.querySelectorAll('.opt-pill').forEach(function(p){var i=p.querySelector('input');p.classList.toggle('sel', !!(i&&i.value===val));});
      g.querySelectorAll('.swatch').forEach(function(p){var i=p.querySelector('input');p.classList.toggle('sel', !!(i&&i.value===val));});
    });
    // Match against variant data by trimmed, case-insensitive option values
    var norm=function(s){return (s==null?'':String(s)).trim().toLowerCase();};
    var vars=embVariants();
    var match=null;
    for(var i=0;i<vars.length;i++){
      var v=vars[i];var ok=true;
      for(var j=0;j<chosen.length;j++){ if(norm(v.opts[j])!==norm(chosen[j])){ok=false;break;} }
      if(ok){match=v;break;}
    }
    var vs=document.getElementById('variantSelect');
    var err=document.getElementById('buyError');
    if(!match){
      // No such combination exists — tell the user plainly instead of silently submitting a default
      if(err){err.textContent='That color and size combination isn\u2019t available. Try another size.';err.style.display='';}
      return;
    }
    if(err){err.style.display='none';}
    if(vs){vs.value=match.id;}
    var jumped=false;
    if(!embSuppressJump && window.embJumpToVariantImage){jumped=window.embJumpToVariantImage(match.id);}
    if(!embSuppressJump && !jumped){var ci=scope.querySelector('input[data-color-input]:checked');if(ci){embJumpToColorImage(ci.value);}}
    // Rebuild price from the matched variant (in cents)
    var pw=document.getElementById('pdpPrice');
    if(pw){
      var html='<span class="price">'+embMoney(match.price)+'</span>';
      if(match.compare&&match.compare>match.price){
        html+='<span class="compare">'+embMoney(match.compare)+'</span>';
        html+='<span class="save">Save '+embMoney(match.compare-match.price)+'</span>';
      }
      pw.innerHTML=html;
    }
    embStickyUpdate(match);
  };

  // ---- Sticky bar details: photo of the chosen color, rating + color name, price with savings ----
  function embVariantData(){
    var el=document.getElementById('variantData');if(!el)return [];
    try{return JSON.parse(el.textContent);}catch(e){return [];}
  }
  function embStickyThumbFor(vid){
    var t=embThumbs();if(!t.length)return null;
    var mid=null,el=document.getElementById('variantImages');
    if(el){try{mid=JSON.parse(el.textContent)[String(vid)]||null;}catch(e){}}
    for(var i=0;i<t.length&&mid;i++){if(t[i].getAttribute('data-media-id')===String(mid)){var im=t[i].querySelector('img');return im?im.getAttribute('src'):null;}}
    var f=t[0].querySelector('img');return f?f.getAttribute('src'):null;
  }
  function embStickyUpdate(v){
    var bar=document.getElementById('stickyBuy');if(!bar||!v)return;
    var sp=document.getElementById('stickyPrice');
    if(sp){
      var sh='<span class="sb-now">'+embMoney(v.price)+'</span>';
      if(v.compare&&v.compare>v.price){sh+=' <span class="sticky-compare">'+embMoney(v.compare)+'</span> <span class="sb-save">Save '+embMoney(v.compare-v.price)+'</span>';}
      sp.innerHTML=sh;
    }
    var th=bar.querySelector('.sticky-buy-thumb'),src=embStickyThumbFor(v.id);
    if(th&&src&&th.getAttribute('src')!==src){th.setAttribute('src',src);}
    var meta=bar.querySelector('.sb-meta');
    if(meta){
      var scope=document.querySelector('.pdp-wrap')||document;
      var ci=scope.querySelector('input[data-color-input]:checked');
      var color=ci?ci.value:((v.opts&&v.opts.length&&v.opts[0]!=='Default Title')?v.opts[0]:'');
      var obs=document.querySelector('.obs-sec');var r=obs?parseFloat(obs.getAttribute('data-rating')):NaN;
      var parts=[];
      if(r>0&&r<=5){parts.push('<span class="sb-star">&#9733;</span> '+r.toFixed(1));}
      if(color){parts.push(embEsc(color));}
      if(parts.length){meta.innerHTML=parts.join(' <span class="sb-dot">&middot;</span> ');bar.classList.add('sb-has-meta');}
    }
  }
  function embInitStickyDetails(){
    var bar=document.getElementById('stickyBuy');if(!bar||bar._embDetails)return;bar._embDetails=true;
    var info=bar.querySelector('.sticky-buy-info');if(!info)return;
    var img=document.createElement('img');img.className='sticky-buy-thumb';img.alt='';img.width=44;img.height=44;
    bar.insertBefore(img,info);
    var meta=document.createElement('div');meta.className='sb-meta';info.insertBefore(meta,info.firstChild);
    var vs=document.getElementById('variantSelect'),vd=embVariantData(),cur=null;
    for(var i=0;i<vd.length;i++){if(vs&&String(vd[i].id)===String(vs.value)){cur=vd[i];break;}}
    embStickyUpdate(cur||vd[0]);
    if(!img.getAttribute('src')){img.parentNode.removeChild(img);}
  }
  document.addEventListener('DOMContentLoaded',embInitStickyDetails);
  window.addEventListener('load',embInitStickyDetails);

  // ---- Scroll reveal (fade sections in) ----
  function embReveal(){
    var els=document.querySelectorAll('.rv:not(.in)');
    var vh=window.innerHeight;
    els.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top < vh - 40){ el.classList.add('in'); }
    });
  }
  window.addEventListener('scroll', embReveal, {passive:true});
  window.addEventListener('load', embReveal);
  document.addEventListener('DOMContentLoaded', embReveal);
  // Safety: if anything is still hidden after 1.2s, force-show it
  setTimeout(function(){ document.querySelectorAll('.rv:not(.in)').forEach(function(el){el.classList.add('in');}); }, 1200);


  // ---- Announcement rotation ----
  (function(){
    var el=document.getElementById('announceMsg');
    if(!el)return;
    var msgs;try{msgs=JSON.parse(el.getAttribute('data-msgs'));}catch(e){return;}
    msgs=(msgs||[]).filter(function(m){return m&&m.length;});
    if(msgs.length<2)return;
    var i=0;
    setInterval(function(){
      i=(i+1)%msgs.length;
      el.style.opacity='0';
      setTimeout(function(){el.textContent=msgs[i];el.style.opacity='1';},250);
    },4500);
  })();


  window.embOpenSize=function(){var m=document.getElementById('sizeModal'),o=document.getElementById('sizeMov');if(m)m.classList.add('show');if(o)o.classList.add('show');};
  window.embCloseSize=function(){var m=document.getElementById('sizeModal'),o=document.getElementById('sizeMov');if(m)m.classList.remove('show');if(o)o.classList.remove('show');};


  window.embBuyNow=function(){
    var form=document.getElementById('productForm');if(!form)return;
    var btn=document.getElementById('buyNowBtn');if(btn){btn.disabled=true;btn.dataset.t=btn.textContent;btn.textContent='Just a sec\u2026';}
    var err=document.getElementById('buyError');if(err){err.style.display='none';}
    var data=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json().then(function(body){return {ok:r.ok,body:body};});})
      .then(function(res){
        if(res.ok&&!res.body.status){window.location.href='/checkout';return;}
        // Add failed (e.g. Shopify says sold out) — show it, do NOT bounce to an empty checkout
        if(btn){btn.disabled=false;btn.textContent=btn.dataset.t;}
        if(err){err.textContent=(res.body&&res.body.description)||(res.body&&res.body.message)||'Sorry, that item could not be purchased right now.';err.style.display='';}
      })
      .catch(function(){
        if(btn){btn.disabled=false;btn.textContent=btn.dataset.t;}
        if(err){err.textContent='Something went wrong. Please try again.';err.style.display='';}
      });
  };

})();

/* v57: live delivery window, 8 to 15 business days from today (weekends skipped) */
(function(){
  function addBiz(d,n){var x=new Date(d.getFullYear(),d.getMonth(),d.getDate());while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--;}return x;}
  function fmt(d){try{return d.toLocaleDateString('en-US',{month:'short',day:'numeric'});}catch(e){return (d.getMonth()+1)+'/'+d.getDate();}}
  function run(){
    var els=document.querySelectorAll('.emb-eta');if(!els.length)return;
    var now=new Date();
    Array.prototype.forEach.call(els,function(el){
      var a=parseInt(el.getAttribute('data-min')||'10',10),b=parseInt(el.getAttribute('data-max')||'18',10);
      el.innerHTML='<span class="eta-a">Free shipping \u00b7</span> <span class="eta-b">Estimated arrival '+fmt(addBiz(now,a)).replace(' ','\u00a0')+' to '+fmt(addBiz(now,b)).replace(' ','\u00a0')+'</span>';
    });
  }
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
